/** Turn provisioning evidence into stable, readable leaf rows.
 *
 * React's implicit String(object) produced "[object Object]" for nested
 * evidence.  Flattening preserves the structure in the key path and keeps the
 * value scalar, so a newer Platform can add nested evidence without requiring
 * an Admin release just to make it legible.
 */
export function evidenceRows(value, prefix = '') {
  if (value === null || value === undefined) {
    return prefix ? [{ key: prefix, value: 'Not reported' }] : [];
  }
  if (Array.isArray(value)) {
    if (value.length === 0) return prefix ? [{ key: prefix, value: 'None' }] : [];
    if (value.every((item) => item === null || typeof item !== 'object')) {
      return [{ key: prefix || 'value', value: value.map(scalarText).join(', ') }];
    }
    return value.flatMap((item, index) => evidenceRows(item, `${prefix}[${index}]`));
  }
  if (typeof value === 'object') {
    return Object.entries(value).flatMap(([key, child]) =>
      evidenceRows(child, prefix ? `${prefix}.${key}` : key));
  }
  return [{ key: prefix || 'value', value: scalarText(value) }];
}

function scalarText(value) {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
}

export function evidenceKeyLabel(key) {
  return String(key || 'value')
    .replace(/_/g, ' ')
    .replace(/\.(?=[^.[])/g, ' › ');
}
